export const SET_USER = 'SET_USER';
export const USER_REGISTER = 'USER_REGISTER';
export const SET_5M = 'SET_5M';
export const SET_15M = 'SET_15M';
export const SET_30M = 'SET_30M';
export const SET1h = 'SET_1h';
export const SET2h = 'SET_2h';
export const SET6h = 'SET_6h';
